/**
 * TutorResourcesScreen — l'onglet « Ressources pédagogiques » de la coquille (`tutor-resources`), à la
 * place de `tutor/home/tutorResources/TutorResources.js` pour un tuteur dont l'espace est allumé.
 * Aucune donnée : des portes (`useTutorResourcesState`). Le référentiel des activités n'est pas porté
 * (décision du 02/11) : la page n'en a plus la ligne.
 */
import React from "react"

import { TutorResourcesPage } from "../../../../../../design-system/tutor"
import { useTutorResourcesState } from "./useTutorResourcesState"

export function TutorResourcesScreen() {
    const state = useTutorResourcesState()

    return <TutorResourcesPage {...state} />
}
